import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import React from 'react';

const buttonVariants = cva(
	'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
	{
		variants: {
			variant: {
				default: 'bg-[#193D6D] text-[#FCD34D] hover:bg-[#FCD34D] hover:text-[#193D6D]',
				destructive: 'bg-red-600 text-white hover:bg-red-700',
				outline: 'border-2 border-[#193D6D] bg-transparent text-[#193D6D] hover:bg-[#193D6D] hover:text-[#FCD34D]',
				secondary: 'bg-[#FCD34D] text-[#193D6D] hover:bg-[#193D6D] hover:text-[#FCD34D]',
				ghost: 'hover:bg-[#193D6D]/10 hover:text-[#193D6D] text-gray-700',
				link: 'text-[#193D6D] underline-offset-4 hover:underline hover:text-[#FCD34D]',
			},
			size: {
				default: 'h-10 px-4 py-2',
				sm: 'h-9 rounded-md px-3',
				lg: 'h-11 rounded-md px-8',
				icon: 'h-10 w-10',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	},
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
	const Comp = asChild ? Slot : 'button';
	return (
		<Comp
			className={cn(buttonVariants({ variant, size, className }))}
			ref={ref}
			{...props}
		/>
	);
});
Button.displayName = 'Button';

export { Button, buttonVariants };